/**
* author: duxin
* date: 2020/4/7
* describe:
*/

<template>
    <div class="service-chunk">
        <p class="p1">{{$t("home.services")}}</p>
        <div class="content-wrap">
            <template v-for="(item,index) in serviceList">
                <div class="block" :key="index">
                    <RouterLink :to="item.href">
                        <i :class="`iconfont ${item.icon}`"></i>
                        <p class="block-title">{{item.title}}</p>
                    </RouterLink>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        name: "me-service-chunk",
        data() {
            return {
                serviceList: [
                    {
                        icon: 'iconOperation',
                        title: this.$t("menu.clinical"),
                        href: '/service/clinical'
                    },
                    {
                        icon: 'iconMedical_affairs',
                        title: this.$t("menu.affairs"),
                        href: '/service/affairs'
                    },
                    {
                        icon: 'iconDrug_Administration',
                        title: this.$t("menu.pharmaceutical"),
                        href: '/service/pharmaceutical'
                    },
                    {
                        icon: 'iconData_management',
                        title: this.$t("menu.management"),
                        href: '/service/management'
                    },
                    {
                        icon: 'iconCall_Center',
                        title: this.$t("menu.call"),
                        href: '/service/call'
                    },
                    {
                        icon: 'iconquality',
                        title: this.$t("menu.auditing"),
                        href: '/service/auditing'
                    },
                    {
                        icon: 'iconpatient',
                        title: this.$t("menu.patient"),
                        href: '/service/patient'
                    },
                    {
                        icon: 'iconPhase_',
                        title: this.$t("menu.drug"),
                        href: '/service/drug'
                    },
                    // {
                    //     icon: 'iconCenter_image',
                    //     title: this.$t("menu.diagnosis"),
                    //     href: '/service/diagnosis'
                    // },
                    {
                        icon: 'icontactics',
                        title: this.$t("menu.medical"),
                        href: '/service/medical'
                    },
                    {
                        icon: 'iconinternatiional',
                        title: this.$t("menu.food"),
                        href: '/service/food'
                    },
                    {
                        icon: 'iconpartner',
                        title: this.$t("menu.partner"),
                        href: '/service/partner'
                    }
                ]
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "./chunk";
    @import "../../../style/constant";

    .service-chunk {
        margin: 100px 0;

        .content-wrap {
            margin: 60px 0 80px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .block {
                width: 15%;
                margin-bottom: 20px;
                height: 210px;
                background: #fafafa;
                border-radius: 8px;
                display: flex;
                justify-content: center;
                transition: box-shadow 0.5s;
                -webkit-transition: box-shadow 0.5s;

                a {
                    text-decoration: none;
                }

                &:hover {
                    cursor: pointer;
                    box-shadow: 0 5px 10px rgba(49, 100, 175, 0.14);
                }

                .iconfont {
                    font-size: 60px;
                    padding-top: 30px;
                    display: inline-block;
                    color: @primary-color;
                    width: 100%;
                    text-align: center;
                }

                @media screen and (min-width: 320px) and (max-width: 480px) {
                    .iconfont {
                        font-size: 40px;
                        padding-top: 10px;
                    }
                }

                .block-title {
                    font-size: 16px;
                    font-weight: 400;
                    color: @primary-color;
                    padding-top: 15px;
                    text-align: center;
                }
            }
        }

        @media screen and (min-width: 320px) and (max-width: 480px) {
            .content-wrap {
                grid-template-columns: repeat(2, 50%);
                margin-top: 40px;

                .block {
                    height: 180px;
                    width: 42vw;
                }
            }
        }
    }

    @media screen and (min-width: 320px) and (max-width: 480px) {
        .service-chunk {
            margin: 40px 0;
            .p1 {
                font-size: 24px;
            }
        }
    }

</style>